import React from 'react';

const PasswordRecoveryContext = React.createContext();

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'setEmail':
      return { ...state, email: payload };
    default:
      throw new Error();
  }
};

const defaultState = {
  email: null,
};

export default PasswordRecoveryContext;
export {
  reducer,
  defaultState,
};
